import React from 'react';
import { RatingsAndReviewMetric } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewMetricTypes';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { BEACON_INDEX_NAMES } from 'src/utils/entityDefinitions/indexes/beaconIndexNames';

const fields = [
  {
    name: RatingsAndReviewMetric.PARENT_LIFETIME_RATING_VOLUME,
    displayName: 'Cumulative Rating Volume'
  },
  {
    name: 'retailSales',
    displayName: 'retailSales',
    displayInTable: false
  },
  {
    name: RatingsAndReviewMetric.PARENT_LIFETIME_RATING,
    displayName: 'Cumulative Avg Star Rating'
  },
  {
    name: RatingsAndReviewMetric.CUMULATIVE_REVIEW_VOLUME,
    displayName: 'Cumulative Review Volume'
  },
  {
    name: RatingsAndReviewMetric.CUMULATIVE_REVIEW_RATING,
    displayName: 'Cumulative Review Rating'
  }
];

export const WeeklyRatingTable = () => {
  const weekEndingFields = fields.map(removeComparisonFormatter);

  return (
    <MetricListContainer
      entityTableHeaderProps={{
        title: 'Cumulative Ratings by Week'
      }}
      indexName={BEACON_INDEX_NAMES.RATINGS_REVIEWS_METRICS_V2}
      sortFieldName="retailSales"
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  );
};
